/* Maison Rosiere — boton "Ajouter au panier" personalizado de la ficha (#mr-atc-form).
   El script original del bloque solo abria el carrito sin refrescarlo, asi que el cliente
   veia el carrito vacio o desactualizado. Este manejador se ejecuta antes (fase de captura),
   anade la variante elegida pidiendo tambien las secciones del carrito y lo vuelve a pintar. */
(function () {
  function selectedVariantId(form) {
    var json = document.querySelector('variant-selects [data-selected-variant]');
    if (json) { try { var v = JSON.parse(json.textContent); if (v && v.id) return v.id; } catch (e) {} }
    var main = document.querySelector('form[action*="/cart/add"]:not(#mr-atc-form) input[name="id"]');
    if (main && main.value) return main.value;
    return form.querySelector('input[name="id"]').value;
  }

  document.addEventListener('submit', function (e) {
    var form = e.target && e.target.closest ? e.target.closest('#mr-atc-form') : null;
    if (!form) return;
    e.preventDefault();
    e.stopImmediatePropagation();

    var btn = form.querySelector('.mr-atc');
    var label = btn ? btn.textContent : '';
    var drawer = document.querySelector('cart-drawer');
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var sections = drawer && drawer.getSectionsToRender ? drawer.getSectionsToRender().map(function (s) { return s.id; }) : [];
    var id = Number(selectedVariantId(form));
    form.querySelector('input[name="id"]').value = id;
    if (btn) btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1 }], sections: sections, sections_url: location.pathname })
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (btn) btn.disabled = false;
        if (state.status) {
          if (btn) { btn.textContent = state.description || 'Indisponible'; setTimeout(function () { btn.textContent = label; }, 2500); }
          return;
        }
        if (drawer && state.sections && typeof drawer.renderContents === 'function') {
          drawer.classList.remove('is-empty');
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
        if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'mr-atc', productVariantId: id, cartData: state });
        }
      })
      .catch(function () { if (btn) btn.disabled = false; window.location.href = root + 'cart'; });
  }, true);
})();
